import { DataTypes } from "../../../data/DataManager";
import { FieldSchema } from "../../../Schema";

/**
 * Whether the software version shown for the cluster comes from this member.
 *
 * Maintained by the cluster screens, not by an equipment edit.
 */
export const isClusterSWVersion: FieldSchema = {
  name: "isClusterSWVersion",
  data: { type: DataTypes.BOOLEAN },
  display: { displayed: false },
  grid: { displayed: false },
  form: { label: "Is cluster software version", disabled: true, displayed: false },
};
